import React from 'react';
import { IconPlus } from '../../app/icons/plus';
import { IconMinus } from '../../app/icons/minus';

export const AccordionIndicator: React.FC<{ open: boolean }> = ({ open }) => (
    <span
        aria-hidden="true"
        className="flex h-[3.2rem] w-[3.2rem] shrink-0 items-center justify-center rounded-full border border-brand-secondary/25 transition-colors duration-200 ease-out motion-reduce:transition-none [&_svg]:h-[1.4rem] [&_svg]:w-[1.4rem]"
    >
        {open ? <IconMinus /> : <IconPlus />}
    </span>
);
